import React from 'react';
import { Map } from 'immutable';
import TMC from '@autonomic/browser-sdk';
import AutoIntl from '@au/core/lib/components/elements/AutoIntl';
import DefaultView from '../View';
import SyncConfigBaseView from './SyncConfigBaseView';
import { pruneCurrentStatusKeys } from '../../../utils/telemetryUtils';
import { generateEntityPath } from '../../../utils/entity';

import styles from '../../../css/components/conversion_sync_config.module.scss';

export default class ConversionSyncConfig extends SyncConfigBaseView {
  syncConfigsEndpoint = new TMC.services.TelemetryDefinition().syncConfigs;

  getSyncEndpoint() {
    return this.syncConfigsEndpoint;
  }

  async loadData() {
    const { endpoint, actions, entityDef, serviceAlias } = this.props;
    let syncConfig;

    try {
      syncConfig = (await this.syncConfigsEndpoint.get(this.entityId)).data;
    } catch (e) {
      // 404 is a legit error, it means there is no sync config for this conversion rule
      if (e.status !== 404) {
        this.genericErrorHandler(e);
      }
    }

    try {
      const conversionRule = (await this.props.endpoint.get(this.entityId)).data;
      const data = { ...conversionRule, syncConfig };
      const path = [...generateEntityPath(endpoint, serviceAlias), this.entityId];
      actions.getEntitySuccess({
        data,
        path,
        pkField: entityDef.pkField,
        replace: true,
      });

      this.onAfterFetch({ data });
    } catch (e) {
      this.genericErrorHandler(e);
    } finally {
      this.setState({ loading: false });
    }
  }

  hasSyncConfig() {
    return Boolean(this.getSyncConfig());
  }

  getSyncConfig(defaultValue) {
    return this.props.entity.get('syncConfig', defaultValue);
  }

  getSyncConfigForDialog() {
    return this.getSyncConfig().toJS();
  }

  pruneAttributes() {
    return pruneCurrentStatusKeys(this.getSyncConfig(Map()), this.props.entityDef.subviews.syncConfig.attributes);
  }

  renderSection() {
    if (this.state.loading) {
      return super.renderSection.call(this); // reuse loading branch via base
    }

    return this.getSyncConfig() ? (
      DefaultView.prototype.renderSection.call(this)
    ) : (
      <AutoIntl displayId='au.telemetry.no.sync.message' className={styles.no_sync_message} tag='div' />
    );
  }
}
